(function () {
  function reveal() {
    document.querySelectorAll('.skin-collection[data-skin-reveal], .skin-collection [data-skin-reveal]').forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) {
        el.classList.add('is-visible');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reveal();
      window.addEventListener('scroll', reveal, { passive: true });
    });
  } else {
    reveal();
    window.addEventListener('scroll', reveal, { passive: true });
  }
})();
